var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('van-empty',{attrs:{"description":"您访问的页面不存在~"}}),_c('el-button',{on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v("返回首页")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }